import {Button, Input, Modal, ModalBody, ModalContent, useDisclosure} from "@heroui/react";
import {useMutation, useQueryClient} from '@tanstack/react-query';
import repositories from '../repositories.jsx';
import toast from 'react-hot-toast';
import {useEffect} from 'react';
import {useForm} from '@mantine/form';

export default function RenameModal({data, openModal = false, ...props}) {
	const {isOpen, onOpen, onClose} = useDisclosure();
	const queryClient = useQueryClient()
	
	const form = useForm({
		initialValues: {
			project_id: data?.project_id,
			title: data?.project_name || '',
		},
	})
	
	const updateProject = useMutation({
		mutationFn: repositories.project.renameProject,
		onSuccess: async () => {
			await queryClient.invalidateQueries(['projects']);
			onClose();
		},
		onError: (error) => {
			console.log(error)
			toast.error(error?.response?.data?.detail || 'Something went wrong')
		}
	})
	
	useEffect(() => {
		openModal ? onOpen() : onClose()
	}, [openModal]);
	
	return (
		<>
			<Modal
				classNames={{
					base: 'overflow-hidden rounded-3xl border border-[#12131714] bg-white shadow-2xl',
					body: 'p-0',
					backdrop: 'bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20 backdrop-blur-sm',
				}}
				size="lg"
				hideCloseButton
				isOpen={isOpen}
				onOpenChange={onClose}>
				<ModalContent>
					{(onClose) => (
						<ModalBody>
							{/* Hero band — primary */}
							<div className="relative overflow-hidden bg-gradient-to-br from-[#7659fa] via-[#8a6cff] to-[#a78bfa] px-8 pt-8 pb-9">
								<div className="pointer-events-none absolute -top-10 -right-8 h-32 w-32 rounded-full bg-white/15 blur-2xl" />
								<div className="pointer-events-none absolute -bottom-12 -left-6 h-32 w-32 rounded-full bg-white/10 blur-2xl" />
								<div className="relative flex items-center gap-4">
									<div className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-white/20 backdrop-blur-sm ring-1 ring-white/40">
										<i className="hgi-stroke hgi-pencil-edit-02 text-2xl text-white"></i>
									</div>
									<div>
										<h2 className="text-xl font-semibold text-white">Rename project</h2>
										<p className="mt-0.5 text-sm font-light text-white/80">Give your project a clearer name.</p>
									</div>
								</div>
							</div>

							{/* Field */}
							<div className="px-6 pt-6">
								<label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-slate-400">Project name</label>
								<Input
									placeholder="Enter project name"
									type="text"
									startContent={<i className="hgi-stroke hgi-folder-01 text-sm text-slate-400" />}
									{...form.getInputProps('title')}
									classNames={{
										inputWrapper: 'h-[44px] bg-[#fcfcfd] rounded-xl border border-[#12131714] focus-within:!border-[#7659fa]',
										input: '!text-sm text-slate-700 placeholder:text-gray-400',
									}}
								/>
							</div>

							{/* Actions */}
							<div className="flex justify-end gap-3 px-6 py-5">
								<Button
									onPress={onClose}
									variant="bordered"
									className="h-11 rounded-xl border-1 border-[#00000014] bg-[#c8ceda4d] px-6 text-sm font-medium text-slate-700 hover:border-slate-700">
									Cancel
								</Button>
								<Button
									isLoading={updateProject.isPending}
									onPress={() => updateProject.mutate(form.values)}
									className="h-11 rounded-xl bg-[#7659fa] px-6 text-sm font-medium text-white shadow-lg shadow-[#7659fa40] transition hover:opacity-95">
									<i className="hgi-stroke hgi-folder-check text-[15px]"></i> Update
								</Button>
							</div>
						</ModalBody>
					)}
				</ModalContent>
			</Modal>
		</>
	);
}
